export default {
	tenantId: "qbe_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "qbe--uat"
	}
}
